import { convertTimestampToDate } from 'helpers';
import { History, HistoryAttachment, HistoryEntry } from 'types';

function populateAttachments(attachmentsData: any): HistoryAttachment[] {
  const attachments = attachmentsData || [];

  return attachments.map((attachment: any) => {
    const { url, mimeType, fileName, created, modified } = attachment;

    return {
      url: url || '',
      mimeType: mimeType || '',
      fileName: fileName || '',
      created: convertTimestampToDate(created || 0),
      modified: convertTimestampToDate(modified || 0),
    };
  });
}

export function historyEntryFactory(params: any = {}): HistoryEntry {
  const {
    date,
    employeeName,
    posName,
    posDisplayName,
    consignmentStatus,
    type,
    description,
    observation,
    attachments,
  } = params;

  return {
    date: convertTimestampToDate(date || ''),
    employeeName: employeeName || '',
    posName: posName || '',
    posDisplayName: posDisplayName || '',
    consignmentStatus: consignmentStatus || '',
    type: type || '',
    description: description || '',
    observation: observation || '',
    attachments: populateAttachments(attachments),
  };
}

function populateHistoryEntries(historyEntriesData: any): HistoryEntry[] {
  const historyEntries = historyEntriesData || [];

  return historyEntries.map((historyEntry: any) =>
    historyEntryFactory(historyEntry)
  );
}

export function historyGetFactory(params: any = {}): History {
  const {
    code,
    orderCode,
    createdDate,
    baseStore,
    status,
    salesMode,
    historyEntries,
  } = params || {};

  return {
    code: code || '',
    orderCode: orderCode || '',
    createdDate: convertTimestampToDate(createdDate || 0),
    baseStore: baseStore?.toLowerCase() || '',
    status: status || '',
    salesMode: salesMode || '',
    historyEntries: populateHistoryEntries(historyEntries),
  };
}
